import React, { useState, useEffect } from "react";
import "./EditVehicleDetails.css";
import grayArrow from "../../../../Assets/Images/grayArrow.svg";
import InputFields from "../../../InputField/TextField/InputField";
import DropDown from "../../../InputField/Dropdown/DropDown";
import Calender from "../../../InputField/Calender/Calender";
import Button from "../../../InputField/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { getBikeBrandAction } from "../../../../Redux/Actions/MmvListAction";
import SearchSelect from "../../../InputField/Searchable-Dropdown/SearchSelect";
import { fetchClientDetails } from "../../../../Redux/Actions/fetchClientDetails";
import Loader from "../../../Layouts/Loader/Loader";
import { getCityAction } from "../../../../Redux/Actions/getStateCityAction";
import ButtonLoader from "../../../Layouts/Loader/Button Loader/ButtonLoader";
import { Tune } from "@mui/icons-material";

const EditVehicleDetails = (props) => {
  const {
    HanldeFormData,
    FormData,
    setFormData,
    setComponentToRender,
    handleBackBtn,
    CallForEdit,
    errors,
    getLoggedInStatus,
    chekEngineLodar,
    getMakeList,
    RsaOnly,
    userMobile

  } = props;
  const dispatch = useDispatch();

  let SubhamMobile = getLoggedInStatus?.data?.loginData?.mobile == "7905933993"
  const [ShowMakeList, setShowMakeList] = useState(false);
  const [ShowModelList, setShowModelList] = useState(false);
  const [ShowVariantList, setShowVariantList] = useState(false);
  const [ShowCClist, setShowCClist] = useState(false);
  const [ShowFuelList, setShowFuelList] = useState(false);
  const [ShowPolicyList, setShowPolicyList] = useState(false);
  const [planAmountforShree, setPlanAmoutforShree] = useState(
    FormData.tenure == 3 &&
      (userMobile == "7705902038" || userMobile == "7007076990")
      ? 3999
      : FormData.tenure == 1 &&
        (userMobile == "7705902038" || userMobile == "7007076990")
        ? 1999
        : FormData.tenure == 5 && userMobile == "7408409585"
          ? 2099
          : FormData.tenure == 1 && userMobile == "9196871592"
            ? 1999
            : FormData.tenure == 5 && userMobile == "9196871592"
              ? 5999
              : 599
  );

  const getclientData = useSelector((state) => {
    return state?.getClientDetails;
  })
  useEffect(() => {
    if (userMobile == "7705902038" || userMobile == "7408409585" || userMobile == "7007076990" || userMobile == "9196871592") {
      setFormData((prevItems) => ({
        ...prevItems,
        planBuyPrice: planAmountforShree,
      }));
    }
  }, [planAmountforShree])
  const clientData = getclientData?.data?.data;
  const handlePopUps = () => {
    if (ShowMakeList) {
      setShowMakeList(!ShowMakeList);
    }
    if (ShowModelList) {
      setShowModelList(!ShowModelList);
    }
    if (ShowVariantList) {
      setShowVariantList(!ShowVariantList);
    }
    if (ShowCClist) {
      setShowCClist(!ShowCClist);
    }
    if (ShowFuelList) {
      setShowFuelList(!ShowFuelList);
    }
    if (ShowPolicyList) {
      setShowPolicyList(!ShowPolicyList);
    }
  };

  const handleCompanyValue = (e) => {
    setFormData((prevItems) => ({
      ...prevItems,
      companyName: e?.value,
    }));
  };
  const handleMakeValue = (e) => {
    setFormData((prevItems) => ({
      ...prevItems,
      make: e?.value,
    }));
  }
  const handleTenureValue = (e) => {
    if (userMobile == "7705902038" || userMobile == "7007076990") {
      if (e.value == 3) {
        setPlanAmoutforShree(3999)
      } else {
        setPlanAmoutforShree(1999)

      }
    }
    if (userMobile == "7408409585") {
      if (e.value == 5) {
        setPlanAmoutforShree(2099)
      } else {
        setPlanAmoutforShree(599)

      }
    }
    if (userMobile == "9196871592") {
      if (e.value == 1) {
        setPlanAmoutforShree(1999);
      } else if (e.value == 5) {
        setPlanAmoutforShree(5999);
      } else {
        setPlanAmoutforShree(599);
      }
    }
    setFormData((prevItems) => ({
      ...prevItems,
      tenure: e?.value,
    }));
  }
  const handleTenureRsaValue = (e) => {
    setFormData((prevItems) => ({
      ...prevItems,
      tenurePa: e?.value,
    }));
  }
  const companyList = [
    { label: "ACKO", value: "ACKO" },
    { label: "UNITED", value: "UNITED" },
    { label: "TATA", value: "TATA" },
    { label: "BAJAJ", value: "BAJAJ" },
    { label: "ZUNO", value: "ZUNO" },
    { label: "SBI", value: "SBI" },
    { label: "HDFC", value: "HDFC" },
    { label: "ICICI", value: "ICICI" },
    { label: "DIGIT", value: "DIGIT" },
    { label: "SHRIRAM", value: "SHRIRAM" },
    { label: "SOMPO", value: "SOMPO" },
    { label: "RELIANCE", value: "RELIANCE" },
    { label: "NATIONAL", value: "NATIONAL" },
    { label: "KIWI GENERAL INSURANCE", value: "KIWI GENERAL INSURANCE" },
    // ➕ Additional verified motor insurance companies
    { label: "ORIENTAL", value: "ORIENTAL" },
    { label: "NEW INDIA", value: "NEW INDIA" },
    { label: "IFFCO TOKIO", value: "IFFCO TOKIO" },
    { label: "KOTAK", value: "KOTAK" },
    { label: "ROYAL SUNDARAM", value: "ROYAL SUNDARAM" },
    { label: "CHOLAMANDALAM", value: "CHOLAMANDALAM" },
    { label: "MAGMA HDI", value: "MAGMA HDI" },
    { label: "NAVi", value: "NAVi" },
    { label: "LIBERTY", value: "LIBERTY" },
    { label: "RAHEJA QBE", value: "RAHEJA QBE" },
    { label: "UNIVERSAL SOMPO", value: "UNIVERSAL SOMPO" },
    { label: "FUTURE GENERALI", value: "FUTURE GENERALI" },
    { label: "ZURICH KOTAK", value: "ZURICH KOTAK" }
  ];
  const tenuteList = [
    {
      label: "One Year",
      value: 1,
    }, {
      label: "Two Year",
      value: 2,
    }, {
      label: "Three Year",
      value: 3,
    },
    {
      label: "Four Year",
      value: 4,
    },
    {
      label: "Five Year",
      value: 5,
    },
  ]
  const tenuteListForShree = [
    {
      label: "One Year",
      value: 1,
    },
    { label: "Three Year", value: 3 },
  ]
  const tenuteListForShreeFirst = [
    {
      label: "One Year",
      value: 1,
    },
    { label: "Five Year", value: 5 },
  ]
  const getTenureList = (formData) => {
    const allTenureList = [
      { label: "One Year", value: 1 },
      { label: "Two Year", value: 2 },
      { label: "Three Year", value: 3 },
      { label: "Four Year", value: 4 },
      { label: "Five Year", value: 5 },
    ];

    // Private Car + New => 1 to 3
    if (
      formData.vehicleType === "Private car" &&
      formData.businessType === "New"
    ) {
      return allTenureList.filter(item => item.value <= 3);
    }

    // Two Wheeler + New => 1 to 5
    if (
      formData.vehicleType === "Two Wheeler" &&
      formData.businessType === "New"
    ) {
      return allTenureList;
    }

    // Default case
    return allTenureList;
  };
  const fetchClientData = () => {
    let data = {
      "data": {
        "engineNo": FormData?.engineNumber,
      }
    }
    dispatch(fetchClientDetails(data));
  }

  useEffect(() => {

    if (clientData) {
      setFormData((prevItems) => ({
        ...prevItems,
        make: clientData?.make,
        model: clientData?.model_varient,
        engineNumber: clientData?.engNo,
        chassisNumber: clientData?.chassisNo,
        policyStartDate: clientData?.policyStartDate,
        firstName: clientData?.firstName,
        lastName: clientData?.lastName,
        mobileNumber: clientData?.phone,
        emailId: clientData?.email,
        addressLineOne: clientData?.address1,
        addressLineTwo: clientData?.address2,
        state: clientData?.state,
        city: clientData?.city,
        pincode: clientData?.pincode,
      }))

      dispatch(getCityAction(FormData?.state ? FormData?.state : clientData?.state))
    }


  }, [clientData])
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      tenurePa: (FormData.vehicleType == "Two Wheeler" && FormData.businessType == "New") || (FormData.vehicleType == "Private car" && FormData.businessType == "New") ? null : 1
    }));
  }, [])



  return (
    <section className="editVehicleDetails-container" onClick={handlePopUps}>

      {getclientData?.isLoading && <Loader />}

      <div className="editVehicleDetails-parent maxWidth">
        <div className="form-container-editVehicleDetails">
          <div className="head-form-container">
            <p>Vehicle details</p>
            <p className="imp-msg">All fields are mandatory</p>
          </div>

          <div className="input-list-editVehicleDetails">

            <div className="input-container-form">
              <div className="input-field-btn" >
                <InputFields
                  type="text"
                  placeholder="Engine Number"
                  name="engineNumber"
                  className="vehicleNumber"
                  onChangeEvent={HanldeFormData}
                  value={FormData.engineNumber}
                  errState={errors?.engineNumber ? true : false}
                  errMsg={errors?.engineNumber}
                  errClassName="input-err"
                />
                {/* <Button
                  text="Fetch"
                  className={FormData.engineNumber ? "fetch-btn" : "fetch-btn disable-fetch-btn"}
                  event={fetchClientData}
                /> */}
              </div>
              <InputFields
                type="text"
                placeholder="Chassis Number"
                name="chassisNumber"
                className="vehicleNumber"
                onChangeEvent={HanldeFormData}
                value={FormData.chassisNumber}
                errState={errors?.chassisNumber ? true : false}
                errMsg={errors?.chassisNumber}
                errClassName="input-err"
              />
            </div>

            <div className="input-container-form">
              {/* <InputFields
                type="text"
                placeholder="Make"
                name="make"
                className="vehicleNumber"
                onChangeEvent={HanldeFormData}
                value={FormData.make}
                errState={errors?.make ? true : false}
                errMsg={errors?.make}
                errClassName="input-err"
              /> */}
              <SearchSelect
                optionList={getMakeList(FormData.vehicleType)}
                handleSelect={handleMakeValue}
                value={FormData?.make}
                placeholder="Select Make"
                label="Make"
                name="Make"
                errState={errors?.make ? true : false}
                errMsg={errors?.make}
                errClassName="input-err"
              />
              <InputFields
                type="text"
                placeholder="Model / Variant"
                name="model"
                className="vehicleNumber"
                onChangeEvent={HanldeFormData}
                value={FormData.model}
                errState={errors?.model ? true : false}
                errMsg={errors?.model}
                errClassName="input-err"
              />
            </div>

            <div className="input-container-form">
              {userMobile == "7705902038" || userMobile == "7408409585" || userMobile == "7007076990" || userMobile=="9196871592"  ?
                <InputFields
                  type="number"
                  placeholder="Enter Plan Price"
                  name="planBuyPrice"
                  className="vehicleNumber"
                  onChangeEvent={() => console.log("Hello")}
                  value={planAmountforShree}
                  errState={errors?.planBuyPrice ? true : false}
                  errMsg={errors?.planBuyPrice}
                  isDisabled="true"
                  errClassName="input-err"
                /> : <InputFields
                  type="number"
                  placeholder="Enter Plan Price"
                  name="planBuyPrice"
                  className="vehicleNumber"
                  onChangeEvent={HanldeFormData}
                  value={FormData.planBuyPrice}
                  errState={errors?.planBuyPrice ? true : false}
                  errMsg={errors?.planBuyPrice}
                  errClassName="input-err"
                />

              }
              <Calender
                className="pForm_datePicker"
                placeholder="Policy Start Date"
                name="policyStartDate"
                id="policyStartDate"
                minDate={true}
                value={FormData.policyStartDate}
                changeEvent={(e) => HanldeFormData(e)}
                errMsg={errors?.policyStartDate}
              />

            </div>

            <div className="input-container-form">


              <SearchSelect
                optionList={companyList}
                handleSelect={handleCompanyValue}
                value={FormData?.companyName}
                placeholder="Select Company"
                label="Company"
                name="Company"
                errState={errors?.companyName ? true : false}
                errMsg={errors?.companyName}
                errClassName="input-err"
              />
              <InputFields
                type="text"
                placeholder="Enter Policy Number"
                name="policyNumber"
                className="vehicleNumber"
                onChangeEvent={HanldeFormData}
                value={FormData.policyNumber}
                errState={errors?.policyNumber ? true : false}
                errMsg={errors?.policyNumber}
                errClassName="input-err"
              />

            </div>

            <div className="input-container-form">
              <SearchSelect
                optionList={(userMobile == "7705902038" || userMobile == "7007076990") ? tenuteListForShree : userMobile == "7408409585" || userMobile == "9196871592" ? tenuteListForShreeFirst : tenuteList}
                handleSelect={handleTenureValue}
                value={FormData?.tenure == 5 ? "Five Year" : FormData?.tenure == 4 ? "Four Year" : FormData?.tenure == 3 ? "Three Year" : FormData?.tenure == 2 ? "Two Year" : "One Year"}
                label="Roadside Assistance Tenure"
                name="tenure"
                errState={errors?.companyName ? true : false}
                errMsg={errors?.companyName}
                errClassName="input-err"
              />



              <div>
                {RsaOnly == 0 &&

                  <SearchSelect
                    optionList={getTenureList(FormData)}
                    handleSelect={handleTenureRsaValue}

                    value={FormData?.tenurePa == 5 ? "Five Year" : FormData?.tenurePa == 4 ? "Four Year" : FormData?.tenurePa == 3 ? "Three Year" : FormData?.tenurePa == 2 ? "Two Year" : FormData?.tenurePa == 1 ? "One Year" : "Select"}
                    label="Compulsory Personal Accident Tenure"
                    name="tenurePa"
                    isDisabled={((FormData.vehicleType == "Two Wheeler" && FormData.businessType == "New") || (FormData.vehicleType == "Private car" && FormData.businessType == "New")) ? false : true}
                    errState={errors?.tenurePa ? true : false}
                    errMsg={errors?.tenurePa}
                    errClassName="input-err"
                  />

                }

              </div>

            </div>

            <div className="btngrp-container">
              <Button
                text="Back"
                className="secondry_btn btn-vehicledetails "
                event={(e) =>
                  handleBackBtn(
                    CallForEdit ? "dropToProductPage" : "editCarDetails"
                  )
                }
              />
              {
                chekEngineLodar ? <ButtonLoader /> : <Button
                  text="Save"
                  className="button btn-vehicledetails "
                  event={(e) =>
                    setComponentToRender(
                      CallForEdit ? "editPersonalDetails" : "editCarDetails"
                    )
                  }
                />
              }


            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

const policyTypeList = [
  { label: "Bundled", value: "Bundled" },
  { label: "Comprehensive", value: "Comprehensive" },
  { label: "Third Party", value: "Third Party" },
  { label: "Own Damage", value: "Own Damage" },
];

export default EditVehicleDetails;
